import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { motion } from 'motion/react';
import { ArrowLeft, GitCompareArrows } from 'lucide-react';
import { StockAnalogueReport } from '@/components/StockAnalogueReport';
import { BETA_DEMO_TICKER } from '@/utils/betaAccess';

export function StockAnalogueAnalysisPage() {
  const navigate = useNavigate();
  const { ticker } = useParams();
  const tickerUpper = ticker?.toUpperCase() || '';

  useEffect(() => {
    if (tickerUpper && tickerUpper !== BETA_DEMO_TICKER) {
      navigate(`/stock/${tickerUpper}`, { replace: true });
    }
  }, [tickerUpper, navigate]);

  return (
    <div className="stock-analogue-analysis-page flex min-h-screen flex-col bg-gray-50 print:bg-white">
      <motion.header
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="stock-analogue-analysis-page__header shrink-0 border-b border-gray-200 bg-white print:hidden"
      >
        <div className="mx-auto flex w-full max-w-7xl items-center gap-4 px-6 py-4">
          <button
            type="button"
            onClick={() => navigate(`/stock/${tickerUpper || BETA_DEMO_TICKER}`)}
            className="rounded-lg p-2 transition-colors hover:bg-gray-100"
            aria-label="Back to stock chart"
          >
            <ArrowLeft className="h-5 w-5" />
          </button>
          <div className="flex min-w-0 flex-1 items-center gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gray-900">
              <GitCompareArrows className="h-5 w-5 text-white" />
            </div>
            <div className="min-w-0">
              <h2 className="tracking-tight text-gray-900">Analogue Analysis</h2>
              <p className="truncate text-sm text-gray-500">
                Wednesday, July 1, 2026 — {tickerUpper || BETA_DEMO_TICKER}
              </p>
            </div>
          </div>
        </div>
      </motion.header>

      <main className="stock-analogue-analysis-page__main mx-auto w-full max-w-7xl flex-1 px-6 py-8 md:py-10 print:max-w-none print:p-0">
        <div className="stock-analogue-analysis-page__shell overflow-hidden rounded-3xl border border-gray-200 bg-white print:overflow-visible print:rounded-none print:border-0 print:shadow-none">
          <StockAnalogueReport />
        </div>
      </main>
    </div>
  );
}
